import {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {clearDataOnDataLayer, pushDataToDataLayer} from './helper';

/**
 * Create a component to map to a field in data layer object, e.g. windows[DATALAYER_WINDOW_KEY]
 * When an instance is mounted to DOM, a data key (props.dataKey) will be set in data layer, and value would be props.data
 * Application can use this component to manage data lifecycle in data layer.
 */
class TrackingMapToDataLayer extends PureComponent {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    data: PropTypes.object,
  };

  componentDidMount() {
    const {dataKey, data} = this.props;
    if (data && dataKey) {
      pushDataToDataLayer({[dataKey]: data});
    }
  }

  componentWillUnmount() {
    const {dataKey} = this.props;
    clearDataOnDataLayer(dataKey);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {data} = this.props;
    const {dataKey: nextDataKey, data: nextData} = nextProps;
    if (data !== nextData) {
      pushDataToDataLayer({[nextDataKey]: nextData});
    }
  }

  render() {
    return null;
  }
}

export default TrackingMapToDataLayer;
